import type { HotelWithSelection } from '@/types/hotel-search';

/** SVG path (viewBox ~ -1.6..1.6) para pin em formato estrela no Google Maps. */
export const EDITORIAL_PICK_STAR_PATH =
  'M 0,-1.55 L 0.47,-0.47 L 1.55,-0.47 L 0.62,0.22 L 0.98,1.55 L 0,0.78 L -0.98,1.55 L -0.62,0.22 L -1.55,-0.47 L -0.47,-0.47 Z';

export function buildHotelMapMarkerIcon(
  maps: typeof google.maps,
  hotel: HotelWithSelection,
  fillColor: string,
  isHighlighted: boolean,
) {
  const scale = isHighlighted ? 16 : 12;
  return {
    path: hotel.editorial_pick ? EDITORIAL_PICK_STAR_PATH : maps.SymbolPath.CIRCLE,
    fillColor,
    fillOpacity: isHighlighted ? 1 : 0.85,
    strokeColor: '#ffffff',
    strokeWeight: isHighlighted ? 3 : 2,
    scale,
  };
}

export function buildHotelMapMarkerZIndex(
  hotel: HotelWithSelection,
  idx: number,
  isHighlighted: boolean,
): number {
  if (isHighlighted) return 1000;
  if (hotel.selection.is_favorite) return 500;
  if (hotel.selection.status === 'chosen') return 450;
  if (hotel.editorial_pick) return 200 + idx;
  return idx;
}
